var React = require('react');

function PortfolioLrg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.3504 6L29.1318 6V13.7713L26.6086 13.7713L26.6079 10.3013L9.0946 27.7934L7.31018 26.0113L24.8241 8.51998L21.3504 8.51998V6Z","fill":"#656976","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.1667 44V31.427H6V44H16.1667ZM8.50744 41.7532H13.6593V33.6738H8.50744V41.7532Z","fill":"#656976","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.0834 44V21.9759H19.9166V44H30.0834ZM22.4241 41.7532H27.5759V24.2227H22.4241V41.7532Z","fill":"#656976","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44 44V8.14925H33.8333V44H44ZM36.3407 41.7532H41.4926V10.3961H36.3407V41.7532Z","fill":"#656976","key":3})]);
}

PortfolioLrg.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = PortfolioLrg;

PortfolioLrg.default = PortfolioLrg;
